import React, {useEffect,useState,useContext} from 'react';
import ProjectContext from '../../ProjectContext.js'

import {useHistory} from 'react-router-dom';
import paidArticlesService from '../../services/api/paid-articles-service.js';
import projectService from '../../services/api/projects-service.js';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardImg,
  CardFooter,
  CardTitle,
  CardText,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
import Select from 'react-select';
import Pagination from 'react-js-pagination';
import moment from 'moment';
import ReactDatetime from 'react-datetime';
import './PaidArticles.css';
import ReactBSAlert from "react-bootstrap-sweetalert";
const closeBtnStyle={
  "border-radius": "50%",
  "padding": "0.5em",
  "width": "30px",
  "height": "30px",
  "border": "1px solid black",
  "color": "black",
  "position": "absolute",
  "background-color" :"#ffffff",
  "pointer-events":"none"
}
const PaidArticleTransactions = (props) => {
    const projectDetails = useContext(ProjectContext);
    const history = useHistory();
    if(projectDetails.id==''){
        history.push("/project/allprojects");
    }
    const project_id = projectDetails.id;
    const [formdetails, setFormDetails] = useState({project_id ,mobile_number:'',amount : '' , order_id: '',from_date :'',to_date:''});
    const [transactions, setTransactions] = useState([]);
    const [totalTransactions, setTotalTransactions] = useState(0);
    const [renderComponent , setRenderComponent] = useState(false);
    const [reloadComponent, setReloadComponent] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [firstRecord, setFirstRecord] = useState(0);
    const [lastRecord, setLastRecord] = useState(0);
    const [showPopup,setShowPopup] = useState({alert:null});
    const [paidArticleEnabled , setPaidArticleEnabled] = useState(false);
    const records = 10;
    useEffect (()=> {
        (async ()=> {
            const projectDetails = await projectService.getProjectDetails(project_id);
            if(projectDetails.status && projectDetails.data) {
                console.log("projectDetails.data",projectDetails.data);
                if(projectDetails.data.settings && projectDetails.data.settings.paid_article === false) {
                    paidArticlesNotEnabledPopup();
                }else{
                    setPaidArticleEnabled(true);
                }
            }
        })();
    },[]);
    useEffect(()=>{
        (async ()=> {
            if(paidArticleEnabled) {
                const response = await paidArticlesService.getTransactions(formdetails,activePage,records);
                if(response.status && response.data) {
                    let transactions = response.data.transactions;
                    setTransactions(response.data.transactions);
                    setTotalTransactions(response.data.counts);
                    if(transactions && transactions.length) {
                        setFirstRecord((activePage-1)*records+1);
                        setLastRecord((activePage-1)*records+ transactions.length);
                    }else{
                        setFirstRecord((activePage-1)*records);
                        setLastRecord((activePage-1)*records+ transactions.length);
                    }
                }
            }
            setRenderComponent(true);
        })();
    },[reloadComponent,paidArticleEnabled]);
    const hidePaidArticlesNotEnabledPopup = () => {
        hideAlert();
        history.push("/dashboard/home");
    }
    const paidArticlesNotEnabledPopup = () => {
        setShowPopup({
        alert: (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Paid Articles"
            onConfirm={hidePaidArticlesNotEnabledPopup}
            showCancel={false}
            btnSize=""
          >
            <Label>This feature is not enabled for your project.If you want to enable please contact to Sortd team.</Label>
          </ReactBSAlert>
        ),
      })
    }
    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        setReloadComponent(Math.random());
    }
    const handleSubmit = function(e){  searchTransaction();e.preventDefault() }

    const searchTransaction = () => {
            setActivePage(1);
            setReloadComponent(Math.random());
    }
    const resetForm = () => {
        setActivePage(1);
        setFormDetails({
        ...formdetails,
        mobile_number :'',
        from_date : '',
        to_date : '',
        amount : '',
        order_id : '',
        });
        setReloadComponent(Math.random());
    }

    const handleChange = (event)=>{
        setFormDetails({
        ...formdetails,
        [event.target.id]: event.target.value,
        });
    }
    const handleDateChange = (event,id) => {
        setFormDetails({
        ...formdetails,
        [id]: event._d,
        });
  }
  const hideAlert = ()=>{
    setShowPopup({alert:null});
  }
  const reviewTransactionPopup = (details) => {
      setShowPopup({
        alert: (
                <ReactBSAlert
                    Success
                    onCancel={() => hideAlert()}
                    style ={{"display":"block","position":"absolute","height" : "auto","width": "50%"}}
                    closeOnClickOutside={true}
                    showCancel={false}
                    showConfirm={false}
                    btnSize=""
                >
                    <Row>
                        <Col>
                        <CardTitle tag="h4" align="left">
                            Order Summary
                            </CardTitle>
                        </Col>
                        <Col align="right">
                            <Button onClick = {() => hideAlert()} className ="closeBtn">X</Button>
                        </Col>   
                    </Row>
                    <Table size="lg" bordered responsive="sm" className="detailsTable">
                        <tr>
                            <td >
                                Order Id
                            </td>
                            <td>
                                {details.order_id}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Email
                            </td>
                            <td>
                                {details.email_id}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Mobile Number
                            </td>
                            <td>
                                {details.mobile_number}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Amount (INR)
                            </td>
                            <td>
                                {details.amount/100}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Article Guid
                            </td>
                            <td>
                                {details.article_guid}
                            </td>
                        </tr>
                        <tr>
                            <td>
                            Article Title
                            </td>
                            <td>
                                {details.article_title}
                            </td>
                        </tr>

                        <tr>
                            <td>
                                Transaction Date
                            </td>
                            <td>
                                {moment(details.createdAt).local().format('dddd DD MMM YYYY hh:mm:ss a')}
                            </td>
                        </tr>
                    </Table>
            </ReactBSAlert> 
        )
      });
    }

    return (
        <div className="content mt-30">
            {showPopup.alert}
            <Container>
                <Card className="text-centercdp-box dp-box">
                    <CardHeader>
                        <CardTitle tag="h4" className="text-center">
                            Paid Articles Sales 
                        </CardTitle>
                        
                    <Form
                        id="transactionFilters"
                        action=""
                        className="form"
                        method="POST"
                        onSubmit={handleSubmit}
                        >
                            <Row>
                                <Col>
                                    <Input
                                        className="mrgin"
                                        value={formdetails.mobile_number}
                                        type="text"
                                        name="mobile_number"
                                        id="mobile_number"
                                        onChange={handleChange}
                                        placeholder="Mobile Number"
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        className="mrgin"
                                        value={formdetails.order_id}
                                        type="text"
                                        name="order_id"
                                        id="order_id"
                                        onChange={handleChange}
                                        placeholder="Order Id"
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        className="mrgin"
                                        value={formdetails.amount}
                                        type="text"
                                        name="amount"
                                        id="amount"
                                        onChange={handleChange}
                                        placeholder="Amount"
                                    />
                                </Col>
                                <Col className="text-center">
                                    <ReactDatetime
                                        className = "mrgin"
                                        value={formdetails.from_date}
                                        onChange={(event)=>handleDateChange(event , "from_date")}
                                        inputProps={{
                                            className: "form-control",
                                            placeholder: "From Date",
                                            id:"from_date",
                                        }
                                        }
                                    />
                                </Col>
                                <Col>
                                    <ReactDatetime
                                        className="mrgin"
                                        value={formdetails.to_date}
                                        onChange={(event)=>handleDateChange(event , "to_date")}
                                        inputProps={{
                                            className: "form-control",
                                            placeholder: "To Date",
                                            id:"to_date",
                                        }}
                                    />
                                </Col>
                                
                                <Col>
                                <Button className="btn-smb" type="submit">
                                    Search
                                </Button>
                                <Button
                                    className="btn-smb"
                                    type="button"
                                    onClick={resetForm}
                                    style={{"backgroundColor":"white !important"}}
                                    >
                                Reset 
                                </Button>
                                </Col>
                                
                            </Row>
                    </Form>
                    {totalTransactions > 0 ? 
                        <div className="pagBox">
                            
                            <div className="pagNo">
                            {firstRecord} - {lastRecord} of {totalTransactions}
                            </div>
                            <div className="pagDgt">
                                
                            <Pagination
                            activePage={activePage}
                            itemsCountPerPage={records}
                            totalItemsCount={totalTransactions}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange.bind(this)}
                            itemClass="page-item"
                            linkClass="page-link"
                            />
                            </div>
                        </div>
                    : null}
                    </CardHeader>
                    
                    {!renderComponent?
                        <div className="text-center">
                            <Spinner className="text-center" animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                        </div>
                    :null}
                <CardBody>
                  <Table responsive>
                    <thead className="text-primary">
                    {renderComponent?
                        <>
                            <th className="text-center">#</th> 
                            <th className="text-center" width="200px" >Mobile Number</th>   
                            <th className="text-center" width="200px">OrderId</th>
                            <th className="text-center" width="150px">Article</th>
                            <th className="text-center" width="150px">Amount (INR)</th>
                            <th className="text-center" width="230px">EmailId</th>
                            <th className="text-center"  width="300px">Transaction On</th>
                            <th className="text-center">Action</th>
                        </>:''}
                    </thead>
                    <tbody>

                        { transactions && transactions.length?transactions.map((details, index)=>(
                        <tr >
                            <td className="text-left">{firstRecord+index}</td>
                            <td className="text-center">
                                {details.mobile_number}
                            </td>
                            <td className="text-center">
                                {details.order_id}
                            </td>
                            <td className="text-center">
                               {details.article_guid}
                            </td>
                            <td className="text-center">
                                {details.amount/100}
                            </td>
                            <td className="text-center">
                                {details.email_id}
                            </td>
                            
                            <td className="text-center">
                                {moment(details.createdAt).format('dddd DD MMM YYYY hh:mm:ss a')}
                            </td>
                            <td className="text-center">
                                <Button className="btn-smb" onClick={(event)=>reviewTransactionPopup(details)}> Review</Button>
                            </td>
                        </tr>
                        ))
                        :
                        null
                        }
                        {renderComponent && (!transactions|| !transactions.length)?
                        <td colspan="12" className="text-center">
                            <CardTitle tag="h4" >No Records Found</CardTitle>
                        </td>:
                        null
                    }
                    </tbody>
                  
                  </Table>

                  
                </CardBody>





                    
                    



                </Card>
                 <div
            className="full-page-background"
            style={{
                backgroundImage: `url(${require("../../assets/img/bg/jan-sendereks.jpg")})`,
            }}
            />
            </Container>
           
        </div>
    );
}

export default PaidArticleTransactions;